module.exports = __webpack_public_path__ + "img/4life-logo-small.c8268d64.png";